import Card from "components/Card";
import Page from "components/Page";
import Text from "components/Text";
import React, { useEffect, useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import editIcon from "../../assets/images/edit-icon.svg";
import deleteIcon from "../../assets/images/delete-icon.svg";
import duplicateIcon from "../../assets/images/duplicate.svg";
import { Tooltip, Row, Col } from "reactstrap";
import DeleteTimeSlotModal from "./components/Modals/DeleteTimeSlotModal";
import constants from "../../constants.js";
import { useParams } from "react-router-dom";
import {
  useGetBusySlot,
  deleteBusySlots,
  getBusySlotIcsLink,
} from "repositories/scheduler-repository";
import Loader from "components/Loader";
import moment from "moment";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import CustomModal from "components/CustomModal";
import AddToCalendar from "accountOwner/pages/components/AddToCalendar";
import { addToCalenderText, decodeId, encodeId, getStorage } from "utils";
import ViewEmployeeModal from "accountOwner/pages/AddEvent/components/ViewEmployeeModal";
import {
  displayCustomMessage,
  MoreTagsFunction,
} from "accountOwner/pages/AddEvent/addEvents.functions";
import InviteesPopup from "accountOwner/pages/EventDetails/components/Modals/InviteesPopup";
import { addEditEventsConst } from "accountOwner/pages/AddEvent/addEvents.constants";
import historyLogsIcon from "./../../assets/images/document_search.svg";
import styles from "./BusyTineslotsDetail.module.scss";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";

const BusyTineslotsDetail = ({ t, history }) => {
  const { profile } = useSelector((state) => state.userProfile);
  const { selectedId, getIdToCheckOwnerChange, selectedOwnerIdString } = useAccountOwnerCommon();
  const isChatFromDashBoard = getStorage(
    constants.notes.cache.isChatFromDashBoard,
  );
  const currentUserId = profile?.id;
  // Tooltip Open state
  const state = history?.location?.state || {};

  useEffect(() => {
    if (getIdToCheckOwnerChange()) {
      goBack();
    }
  }, [selectedId]);

  const goBack = () => {
    if(window.history.length > 1){
      return history.goBack();
    }
    if (state.fromScreen === "schedulingAssistant") {
      if (state.eventId) {
        history.push({
          pathname: constants.routes.scheduler.editEvent.replace(
            ":eventId",
            state.eventId
          ),
          state: {
            ...state.schedulingAssistantState,
            requestedDate: state.requestedDate,
            setSchedulingAssistantTab: true,
          },
        });
      } else {
        history.push({
          pathname: "/add-event",
          state: {
            ...state.schedulingAssistantState,
            requestedDate: state.requestedDate,
            setSchedulingAssistantTab: true,
          },
        });
      }
      return;
    }

    if (isChatFromDashBoard) {
      history.push(constants.routes.dashboard.managerDashboard);
    } else {
      history.push(constants.routes.scheduler.calendar);
    }
  };
  let { busySlotId } = useParams();
  busySlotId = decodeId(busySlotId);

  const [tooltipEditOpen, setTooltipEditOpen] = useState(false);
  const [tooltipDeleteOpen, setTooltipDeleteOpen] = useState(false);
  const [tooltipHistoryLogsOpen, setTooltipHistoryLogsOpen] = useState(false);
  const [tooltipDuplicateOpen, setTooltipDuplicateOpen] = useState(false);
  const [isDeleteTimeSlotModalOpen, setIsDeleteTimeSlotModalOpen] =
    useState(false);
  const [toolTipModal, setToolTipModal] = useState(false);
  const [isSaveEmployeeModalOpen, setIsSaveEmployeeModalOpen] = useState(false);
  const [nonInvitePopup, setNonInvitePopup] = useState(false);
  const requestedDate = state?.requestedDate;
  let SchedulerBusySlotDate = moment(requestedDate).format("YYYY-MM-DD");
  const {
    isLoading,
    isFetching,
    data: busySlot,
    error,
  } = useGetBusySlot(busySlotId, SchedulerBusySlotDate, {
    enabled: !!busySlotId,
  });
  const isAdmin = profile?.isAdmin;
  const isAccountOwner =
    profile && profile?.role
      ? profile.role.systemRole === constants.systemRoles.accountOwner
      : false;
  // Allow owners and admins to duplicate busy slots
  const showEditDelIcons =
    busySlot?.data?.createdById === currentUserId || isAccountOwner || isAdmin;

  const [invitePopupPosition, setInvitePopupPosition] = useState({
    top: 0,
    right: 0,
  });
  const handlePopupToggle = (event, setter) => {
    event.stopPropagation();
    setInvitePopupPosition({
      top: 25,
      right: 0,
    });
    setter((prev) => !prev);
  };

  useEffect(() => {
    if (!isLoading && !isFetching && error?.message) {
      toast.error(error?.message);
    }
    //eslint-disable-next-line
  }, [error]);

  const [isDownloading, setIsDownloading] = useState(false);

  const handleAddToCalendar = async () => {
    setIsDownloading(true);
    try {
      const url = await getBusySlotIcsLink(busySlotId);
      window?.open(url, "_self");
      toast.success(t("fileDownloaded"));
    } catch (err) {
      toast.error(err?.message);
    }
    setIsDownloading(false);
  };

  const getRepeatString = (repeatedType, busySlotDate) => {
    if (repeatedType === 1) {
      return t("scheduler.never");
    } else if (repeatedType === 2) {
      return (
        t("scheduler.repeatForAll") +
        " - " +
        moment(busySlotDate).format("dddd")
      );
    } else if (repeatedType === 3) {
      return t("scheduler.repeatForAllFuture");
    }
  };

  const deleteSlot = async () => {
    try {
      let response = await deleteBusySlots(busySlotId);
      if (response?.statusCode === 200) {
        toast.success(response?.message);
        setIsDeleteTimeSlotModalOpen(false);
        goBack();
      }
    } catch (err) {
      toast.error(err?.message);
    }
  };

  let busySlotDetails = {};
  if (busySlot?.data) {
    busySlotDetails.officeName = busySlot?.data?.schedulerBusySlotOffice;
    busySlotDetails.title = busySlot?.data?.title;
    busySlotDetails.repeatedText = getRepeatString(
      busySlot?.data?.repeatedType,
      busySlot?.data?.date,
    );
    busySlotDetails.startTime = moment(busySlot?.data?.startTime).format(
      "h:mm A",
    );
    busySlotDetails.endTime = moment(busySlot?.data?.endTime).format("h:mm A");
    busySlotDetails.date = moment(busySlot?.data?.date)?.format(
      "MMM DD, YYYY - ddd",
    );
    busySlotDetails.location = busySlot?.data?.location;
    busySlotDetails.description = busySlot?.data?.description;
    busySlotDetails.repeated = busySlot?.data?.repeatedType > 1;
    busySlotDetails.endDate = moment(busySlot?.data?.repeatedEndDate).format(
      "MMM DD, YYYY - ddd",
    );
    busySlotDetails.busySlotNotifiedUsers =
      busySlot?.data?.busySlotNotifiedUsers;
    busySlotDetails.customRepeatPattern = busySlot?.data?.customRepeatPattern;
    busySlotDetails.repeatedType = busySlot?.data?.repeatedType;
  }
  const eventKey = useMemo(
    () => ({
      eventOrShift: t(
        `accountOwner.${busySlotDetails?.isShift ? "shift" : "event"}Tab`,
      ),
    }),
    [busySlotDetails?.isShift],
  );

  const repeatMessagesDisplay = useMemo(() => {
    if (!busySlotDetails.customRepeatPattern) return "";
    let isFromBusySlot = true;
    return displayCustomMessage(busySlotDetails, isFromBusySlot);
  }, [busySlotDetails?.customRepeatPattern]);

  return (
    <Page onBack={goBack} title={t("accountOwner.busyTimeslotDetails")}>
      {(isLoading || isDownloading) && <Loader />}
      <Card
        className={styles["busyslot-detail-card"] + " " + "margin30"}
        radius="10px"
        marginBottom="18px"
        shadow="0 0 15px 0 rgba(0, 0, 0, 0.08)"
      >
        <div className="d-flex justify-content-end">
          {showEditDelIcons && (
            <div className={styles["delete-edit-icons"]}>
              <img
                src={duplicateIcon}
                alt="duplicate"
                id="TooltipDuplicateBtn"
                onClick={() => {
                  history.push({
                    pathname:
                      constants.routes.scheduler.duplicateBusySlot.replace(
                        ":busySlotId",
                        encodeId(busySlotId),
                      ),
                    state: {
                      duplicateBusySlot: true,
                      requestedDate: requestedDate,
                    },
                    search: selectedOwnerIdString ? `?${selectedOwnerIdString}` : "",
                  });
                }}
                style={{ cursor: "pointer" }}
              />
              <Tooltip
                isOpen={tooltipDuplicateOpen}
                placement="top"
                target="TooltipDuplicateBtn"
                toggle={() => {
                  setTooltipDuplicateOpen(!tooltipDuplicateOpen);
                }}
              >
                {t("scheduler.duplicateEvent", {
                  eventOrShiftOrLeave: t("accountOwner.busyTimeslot"),
                })}
              </Tooltip>
              <img
                src={historyLogsIcon}
                alt="history_logs"
                id="TooltipHistoryLogsBtn"
                className={styles.history_logs_icon}
                onClick={() => {
                  history.push({
                    pathname:
                      constants.routes.scheduler.busySlotHistoryLogs.replace(
                        ":busySlotId",
                        encodeId(busySlotId),
                      ),
                    state: {
                      requestedDate: requestedDate,
                      eventEmployeesList:
                        busySlotDetails?.busySlotNotifiedUsers,
                      eventRepeatedEndDate: busySlotDetails?.repeatedEndDate,
                      isShift: true,
                    },
                    search: selectedOwnerIdString ? `?${selectedOwnerIdString}` : "",
                  });
                }}
              />
              <Tooltip
                isOpen={tooltipHistoryLogsOpen}
                placement="top"
                target="TooltipHistoryLogsBtn"
                toggle={() => {
                  setTooltipHistoryLogsOpen(!tooltipHistoryLogsOpen);
                }}
              >
                {t("scheduler.historyLogs", {
                  eventOrShiftOrLeave: t("accountOwner.busyTimeslot"),
                })}
              </Tooltip>

              <img
                src={deleteIcon}
                alt="delete"
                id="TooltipDeleteBtn"
                onClick={() => {
                  history.push({
                    pathname: constants.routes.scheduler.deleteBusySlot.replace(
                      ":busySlotId",
                      encodeId(busySlotId),
                    ),
                    state: { requestedDate },
                    search: selectedOwnerIdString ? `?${selectedOwnerIdString}` : "",
                  });
                }}
              />
              <Tooltip
                isOpen={tooltipDeleteOpen}
                placement="top"
                target="TooltipDeleteBtn"
                toggle={() => {
                  setTooltipDeleteOpen(!tooltipDeleteOpen);
                }}
              >
                Delete Timeslot
              </Tooltip>
              <img
                src={editIcon}
                alt="edit"
                id="TooltipEditBtn"
                onClick={() => {
                  history.push({
                    pathname: constants.routes.scheduler.editBusySlot.replace(
                      ":busySlotId",
                      encodeId(busySlotId),
                    ),
                    state: { date: requestedDate },
                    search: selectedOwnerIdString ? `?${selectedOwnerIdString}` : "",
                  });
                }}
              />

              <Tooltip
                isOpen={tooltipEditOpen}
                placement="top"
                target="TooltipEditBtn"
                toggle={() => {
                  setTooltipEditOpen(!tooltipEditOpen);
                }}
              >
                Edit Timeslot
              </Tooltip>
            </div>
          )}
        </div>
        <Row>
          <Col lg="6">
            <ul className={styles["white-col-list"]}>
              {
                <li>
                  <Text
                    size="12px"
                    marginBottom="5px"
                    weight="400"
                    color="#6f7788"
                  >
                    {t("accountOwner.offices")}
                  </Text>
                  <p className={styles.invitees_p_text}>
                    <MoreTagsFunction
                      value={
                        busySlotDetails?.officeName?.filter(
                          (item) => !item?.isDeletedForThisSchedulerBusySlot,
                        ) || []
                      }
                      lastIndex={2}
                      clickHandler={(e) =>
                        handlePopupToggle(e, setNonInvitePopup)
                      }
                      mapFn={(member) => `${member?.office?.name}`}
                    />

                    {nonInvitePopup && (
                      <InviteesPopup
                        position={invitePopupPosition}
                        handleInvitePopupToggle={(e) =>
                          handlePopupToggle(e, setNonInvitePopup)
                        }
                        list={busySlotDetails?.officeName?.filter(
                          (item) => !item?.isDeletedForThisSchedulerBusySlot,
                        )}
                        showRoleAndOffice={false}
                        isForEvent={true}
                        onlyOfffice
                      />
                    )}
                  </p>
                </li>
              }

              <li>
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("title")}
                </Text>
                <Text size="14px" marginBottom="0" weight="600" color="#102c42">
                  {busySlotDetails.title}
                </Text>
              </li>
              <li>
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("accountOwner.date")}
                </Text>
                <Text size="14px" marginBottom="0" weight="600" color="#102c42">
                  {busySlotDetails.date}
                </Text>
              </li>
              <li>
                <Row>
                  <Col sm="6">
                    <Text
                      size="12px"
                      marginBottom="5px"
                      weight="400"
                      color="#6f7788"
                    >
                      {t("staff.startTime")}
                    </Text>
                    <Text
                      size="14px"
                      marginBottom="0"
                      weight="600"
                      color="#102c42"
                    >
                      {busySlotDetails.startTime}
                    </Text>
                  </Col>
                  <Col sm="6">
                    <Text
                      size="12px"
                      marginBottom="5px"
                      weight="400"
                      color="#6f7788"
                    >
                      {t("accountOwner.endTime")}
                    </Text>
                    <Text
                      size="14px"
                      marginBottom="0"
                      weight="600"
                      color="#102c42"
                    >
                      {busySlotDetails.endTime}
                    </Text>
                  </Col>
                </Row>
              </li>
              <li>
                <Row>
                  <Col sm="6">
                    <Text
                      size="12px"
                      marginBottom="5px"
                      weight="400"
                      color="#6f7788"
                    >
                      {t("repeat")}
                    </Text>
                    <Text
                      size="14px"
                      marginBottom="0"
                      weight="600"
                      color="#102c42"
                    >
                      {
                        addEditEventsConst
                          .repeatedOptions(t)
                          .find(
                            (res) => busySlotDetails?.repeatedType === res.id,
                          )?.name
                      }
                    </Text>
                    {busySlotDetails?.repeatedType && repeatMessagesDisplay && (
                      <Text
                        size="11px"
                        marginBottom="0"
                        weight="400"
                        color="#79869A"
                      >
                        {repeatMessagesDisplay}
                      </Text>
                    )}
                  </Col>
                </Row>
              </li>
              {busySlotDetails.repeated && (
                <li>
                  <Text
                    size="12px"
                    marginBottom="5px"
                    weight="400"
                    color="#6f7788"
                  >
                    {t("superAdmin.endDate")}
                  </Text>
                  <Text
                    size="14px"
                    marginBottom="0"
                    weight="600"
                    color="#102c42"
                  >
                    {busySlotDetails.endDate}
                  </Text>
                </li>
              )}
              <li>
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("location")}
                </Text>
                <Text
                  size="14px"
                  marginBottom="5px"
                  weight="600"
                  color="#102c42"
                >
                  {busySlotDetails.location}
                </Text>
              </li>
              <li>
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("accountOwner.notifiedEmployee")}
                </Text>
                <Text size="14px" marginBottom="0" weight="600" color="#102c42">
                  {busySlotDetails?.busySlotNotifiedUsers?.length === 0 ? (
                    <small>{t("accountOwner.noEmployeesSelected")}</small>
                  ) : (
                    <MoreTagsFunction
                      value={busySlotDetails?.busySlotNotifiedUsers || []}
                      lastIndex={2}
                      clickHandler={(e) => setIsSaveEmployeeModalOpen(true)}
                      mapFn={(member) =>
                        `${member?.user?.firstName} ${member?.user?.lastName}`
                      }
                    />
                  )}
                </Text>
              </li>
              <li>
                <Text
                  size="12px"
                  marginBottom="5px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("superAdmin.description")}
                </Text>
                <Text size="14px" marginBottom="0" weight="600" color="#102c42">
                  {busySlotDetails.description}
                </Text>
              </li>
              {showEditDelIcons && (
                <li>
                  <AddToCalendar
                    firstIcon={
                      require("assets/images/download-icon.svg").default
                    }
                    middleText={t("accountOwner.addToCalendar")}
                    secondIcon={
                      require("assets/images/alert-circle.svg").default
                    }
                    handleAddToCalendar={handleAddToCalendar}
                    setToolTipModal={setToolTipModal}
                  />
                </li>
              )}
            </ul>
          </Col>
        </Row>
      </Card>
      {isDeleteTimeSlotModalOpen && (
        <DeleteTimeSlotModal
          isDeleteTimeSlotModalOpen={isDeleteTimeSlotModalOpen}
          deleteSlot={deleteSlot}
          setIsDeleteTimeSlotModalOpen={setIsDeleteTimeSlotModalOpen}
        />
      )}
      {isSaveEmployeeModalOpen && (
        <ViewEmployeeModal
          issaveEmployeeModalOpen={isSaveEmployeeModalOpen}
          setIsSaveEmployeeModalOpen={setIsSaveEmployeeModalOpen}
          allMembersList={busySlotDetails?.busySlotNotifiedUsers}
          isFromBusySlotdetail={true}
        />
      )}
      <CustomModal
        isOpen={toolTipModal}
        setIsOpen={setToolTipModal}
        title={t("accountOwner.addToCalendar")}
        subTitle1={addToCalenderText(eventKey.eventOrShift.toLowerCase())}
        calender={true}
      />
    </Page>
  );
};

export default withTranslation()(BusyTineslotsDetail);
